export const ERA_PRO_DOSE_OPTIONS = [
  { active: false, label: "1", value: 1 },
  { active: false, label: "2", value: 2 },
  { active: false, label: "3", value: 3 },
  { active: false, label: "4", value: 4 },
];

export const ERA_PRO_LOCKOUT_TIME = 5;
